import { createAction } from 'redux-actions';
export const setSubmittedOtaToken = createAction('CREDIT_PORTAL/SET_SUBMITTED_OTA_TOKEN');
